import { createSlice } from "@reduxjs/toolkit";


export const mvocSlice = createSlice({
  name: "MvocMetadata",
  initialState: {
    
    currentMVOCMetadata: {},
    mvocdetails:{},
    attachmentRows:[],
   
  },
  reducers: {
  
    setCurrentMVOCMetaData: (state, action) => {
        state.currentMVOCMetadata = action.payload;
    },
    resetCurrentMVOCMetaData: (state) => {
        state.currentMVOCMetadata = {};
    },
    setAttachmentRows: (state, action) => {
        state.attachmentRows = action.payload;
    },
    resetAttachmentRows:(state)=>{
      state.attachmentRows=[];
    }
   

},
});

export const {setCurrentMVOCMetaData,resetCurrentMVOCMetaData,setAttachmentRows,resetAttachmentRows} = mvocSlice.actions;

export default mvocSlice.reducer;
